import request from '@/utilities/request'

// Location
export function getLocations () {
  return request({
    url: '/location',
    method: 'get'
  })
}

export function getInvs () {
  return request({
    url: '/location/inv',
    method: 'get'
  })
}

export function storeLocation (formData) {
  return request({
    url: '/location',
    method: 'post',
    data: formData
  })
}

export function getLocation (id) {
  return request({
    url: '/location/' + id,
    method: 'get'
  })
}

export function updateLocation (id, formData) {
  return request({
    url: '/location/' + id + '/update',
    method: 'post',
    data: formData
  })
}

// export function deleteLocation (rack_id) {
//   return request({
//     url: '/location/' + rack_id + '/delete',
//     method: 'post'
//   })
// }
